export class RestoreDestinationLimits {
    'effect';
    'restoreAccountProviderIds';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "effect",
            "baseName": "effect",
            "type": "AccessConditionEffect",
            "format": ""
        },
        {
            "name": "restoreAccountProviderIds",
            "baseName": "restoreAccountProviderIds",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreDestinationLimits.attributeTypeMap;
    }
    constructor() {
    }
}
